<template>
    <el-popover
        placement="bottom-start"
        width="388"
        trigger="manual"
        popper-class="psw-valid-popper"
        v-model="visible"
        >
        <!-- :value="true" -->
        <slot slot="reference"></slot>
        <div id="psw-valid-warp">
            <div class="psw-valid">
                <div>
                    <el-checkbox v-model="checkLengthRule" disabled>至少需包含8个字符</el-checkbox>
                </div>
                <div class="check-rules-group-warp">
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAllRule"
                        @change="handleCheckAllRuleChange"
                        disabled
                        >需包含下列4项</el-checkbox
                    >
                    <el-checkbox-group
                        v-model="checkedRules"
                        @change="handleCheckedRulesChange"
                        class="check-rules-group"
                        disabled
                    >
                        <el-checkbox
                        v-for="rule in rules"
                        :label="rule.value"
                        :key="rule.value"
                        >{{ rule.label }}</el-checkbox
                        >
                    </el-checkbox-group>
                </div>
            </div>
        </div>
  </el-popover>
  
</template>

<script>
export default {
  props: {
      checkValue: {
        required: true
      }
  },
  data() {
    return {
        visible: false,
      checkLengthRule: false,
      checkAllRule: false,
      checkedRules: [],
      isIndeterminate: false,
      rules: [
        {
          value: "1",
          label: "1个大写字母",
          include: /[A-Z]{1}/,
        },
        {
          value: "2",
          label: "1个小写字母",
          include: /[a-z]{1}/
        },
        {
          value: "3",
          label: "1个数字（0-9）",
          include: /[0-9]{1}/
        },
        {
          value: "4",
          label: "1个特殊字符（不包含^%&',;=?$）",
          include: new RegExp("[`~!@#*()|{}:\\[\\].<>《》/~！@#￥……&*（）——|{}【】‘；：”“'。，、 ]")
        },
      ]
    };
  },
  watch: {
    checkValue: {
        handler (val) {
            if (val) {
                if (val.length >= 8) {
                    this.checkLengthRule = true
                }
                this.checkedRules = this.rules.filter(rule => rule.include.test(val) && (!rule.exclude || !rule.exclude.test(val))).map(rule => rule.value)
            } else {
                this.checkLengthRule = false
                this.checkedRules = []
            }
            this.handleCheckedRulesChange(this.checkedRules)
        },
        immediate: true
    }
  },
  methods: {
    handleCheckAllRuleChange(val) {
      this.checkedRules = val ? this.rules.map((rule) => rule.value) : [];
      this.isIndeterminate = false;
    },
    handleCheckedRulesChange(value) {
      let checkedCount = value.length;
      this.checkAllRule = checkedCount === this.rules.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.rules.length;
    },
  }
};
</script>

<style lang="less">
.psw-valid-popper.el-popper[x-placement^=bottom] {
    margin-top: 20px;
}
#psw-valid-warp {
    .psw-valid {
        padding-top: 5px;
        line-height: 1;
        
        .el-checkbox {
            line-height: 24px;
            .el-checkbox__input.is-disabled+span.el-checkbox__label {
                color: #606266;
                cursor: pointer;
            }
            .el-checkbox__input.is-checked.is-disabled .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate.is-disabled .el-checkbox__inner {
                background-color: #07c160;
                border-color: #07c160;
            }
            .el-checkbox__input.is-disabled .el-checkbox__inner {
                background-color: #ffffff;
            }
            .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
                border-color: #ffffff;
            }
            .el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner::before {
                background-color: #ffffff;
                border-color: #ffffff;
            }
        }
        .check-rules-group-warp {
            .el-checkbox-group.check-rules-group {
                display: flex;
                flex-direction: column;
                .el-checkbox {
                    padding-left: 20px;
                }
            }
        }
    }
}
</style>